module.exports = __webpack_public_path__ + "media/images/lb/877-280ab48962e26b1d7189c2ea28486bd7.svg";